import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
  selector: 'app-testimonial-type01',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, HeadingSectionType01Component,SlickCarouselModule],
  templateUrl: './testimonial-type01.component.html',
  styleUrl: './testimonial-type01.component.scss'
})
export class TestimonialType01Component implements OnInit {

  public view: any = {
  }

  constructor(public _tfmService : TFMService, private route: ActivatedRoute) {

    // this._tfmService.getTestimonials().then(res => {
    //   this.view.testimonials = res;
    //   console.log(this.view.testimonials);
    // });

    this._tfmService.getTestimonials().then(res => {
      this.view.testimonials = (res.content || []).map((t: any) => {
        try {
          t.metaDataParsed = JSON.parse(t.metaData);
        } catch {
          t.metaDataParsed = {};
        }
        return t;
      });
      // console.log(this.view.testimonials);
    });    
    
  }

  ngOnInit(): void {
      this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        // this._tfmService.log(this.view);

      });
  }
  
  slideConfig = {
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    responsive: [
    {
      breakpoint: 1424,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  };
  
  slickInit(e) {
    this._tfmService.log('slick initialized');
  }
  
  breakpoint(e) {
    this._tfmService.log('breakpoint');
  }
  
  afterChange(e) {
  }
  
  beforeChange(e) {
  }

}
